import { List as ImmutableList } from 'immutable';
import { ImmutableObject } from 'common/state/interfaces';
import { IEmployeeBasicInfoImt } from 'common/interfaces/common';
import { EventType } from 'modules/booking/interfaces';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';

export interface ICrmDashboardStats {
  leadsContacted: number;
  leadAppointments: number;
  membersContacted: number;
  memberAppointments: number;
  sales: number;
  averageDaysToSell: number;
}

export interface ICrmDashboardStatsImt extends ImmutableObject<ICrmDashboardStats> {
  get<K extends keyof ICrmDashboardStats>(key: K): ICrmDashboardStats[K];
}

export interface IConversionRateItem {
  employee: IEmployeeBasicInfo;
  numberOfSales: number;
  totalAmountSold: number;
}

export interface IConversionRateItemImt extends ImmutableObject<IConversionRateItem> {
  get<K extends keyof IConversionRateItem>(key: K): IConversionRateItem[K];
  get(key: 'employee'): IEmployeeBasicInfoImt;
}

export interface IMembershipsSoldItem {
  title: string;
  count: number;
  id: string;
}

export interface IMembershipsSoldItemImt extends ImmutableObject<IMembershipsSoldItem> {
  get<K extends keyof IMembershipsSoldItem>(key: K): IMembershipsSoldItem[K];
}

export enum ActivityTypes {
  EMAILS = 'EMAILS',
  CALLS = 'CALLS',
  SMS = 'SMS',
}

// Appointments

export interface IAppointmentSimpleDto {
  id: string;
  type: EventType;
  date: string;
  salesperson: IEmployeeBasicInfo;
}

export interface IAppointmentSimpleDtoImt extends ImmutableObject<IAppointmentSimpleDto> {
  get<K extends keyof IAppointmentSimpleDto>(key: K): IAppointmentSimpleDto[K];
  get(key: 'salesperson'): IEmployeeBasicInfoImt;
}

// Backlog

export interface IBacklogItem {
  id: string;
  type: ActivityTypes;
  date: string;
  salesperson: IEmployeeBasicInfo;
  total: number;
}

export interface IBacklogItemImt extends ImmutableObject<IBacklogItem> {
  get<K extends keyof IBacklogItem>(key: K): IBacklogItem[K];
  get(key: 'salesperson'): IEmployeeBasicInfoImt;
}

export interface IBacklog {
  data: IBacklogItem[];
}

// Activity

export interface ICrmActivityItem {
  id: string;
  type: ActivityTypes;
  amount: number;
  date: string;
}

export type ICrmActivityItemImt = ImmutableObject<ICrmActivityItem>;

export interface ICrmActivityRecord {
  id: string;
  type: ActivityTypes;
  color?: string;
  data: ICrmActivityItem[];
}

export interface ICrmActivityRecordImt extends ImmutableObject<ICrmActivityRecord> {
  get<K extends keyof ICrmActivityRecord>(key: K): ICrmActivityRecord[K];

  get(key: 'data'): ImmutableList<ICrmActivityItemImt>;
}

export interface ICrmActivity {
  data: ICrmActivityRecord[];
}
